import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/multiLocationSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const rangeOptions = useSelector((state) => state.multiLocation.rangeOptions);
  const selectedRangeOption = useSelector((state) => state.multiLocation.selectedRangeOption);

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      selectedFilters={selectedRangeOption}
      includeFilter={false}
      onSelectChange={(data) => dispatch(actionCreators.updateCustomRange(data))}
    />
  );
};

export default CustomDateRanges;
